export const system = "Manage" as const;
